import { render, staticRenderFns } from "./ListNewProduct.vue?vue&type=template&id=acffea76&scoped=true"
import script from "./ListNewProduct.vue?vue&type=script&lang=js"
export * from "./ListNewProduct.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/table-admin-styles.css?vue&type=style&index=0&id=acffea76&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acffea76",
  null
  
)

export default component.exports